import {
  identifyAndSubmitInteraction as originalIdentifyAndSubmit,
  setTrustedDeviceOptInDecision as originalSetTrustedDeviceOptInDecision,
  submitInteraction as originalSubmit,
} from 'monoai:original?apis/experience/interaction';

import { recordSignInSuccess } from '@/utils/last-sign-in-method';

export * from 'monoai:original?apis/experience/interaction';

type IdentificationPayload = Parameters<typeof originalIdentifyAndSubmit>[0];

// Every completed interaction passes through one of these submissions. The
// original module calls its own submitInteraction internally, so the two
// composite exports are wrapped as well.
export async function submitInteraction() {
  const result = await originalSubmit();
  recordSignInSuccess();
  return result;
}

export async function identifyAndSubmitInteraction(payload?: IdentificationPayload) {
  const result = await originalIdentifyAndSubmit(payload);
  recordSignInSuccess();
  return result;
}

export async function setTrustedDeviceOptInDecision(trusted: boolean) {
  const result = await originalSetTrustedDeviceOptInDecision(trusted);
  recordSignInSuccess();
  return result;
}
